import { Routes, Route, Navigate } from 'react-router-dom'
import RequireAuth from './components/shell/RequireAuth.jsx'
import AppShellLayout from './components/shell/AppShellLayout.jsx'
import LoginPage from './pages/LoginPage.jsx'
import LauncherPage from './pages/LauncherPage.jsx'
import LiveSessionPage from './pages/LiveSessionPage.jsx'
import ReviewSessionPage from './pages/ReviewSessionPage.jsx'
import SessionsListPage from './pages/SessionsListPage.jsx'
import ClientsListPage from './pages/ClientsListPage.jsx'
import ClientNewPage from './pages/ClientNewPage.jsx'
import ClientDetailPage from './pages/ClientDetailPage.jsx'
import SettingsPage from './pages/SettingsPage.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShellLayout />}>
          <Route path="/" element={<SessionsListPage />} />
          <Route path="/sessions/new" element={<LauncherPage />} />
          <Route path="/sessions/live/:id" element={<LiveSessionPage />} />
          <Route path="/sessions/:id" element={<ReviewSessionPage />} />
          <Route path="/clients" element={<ClientsListPage />} />
          <Route path="/clients/new" element={<ClientNewPage />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
